/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as styles from './style';
import { ModalComponent } from "../../../ModalComponent";
import CTA, { CTATheme } from "../../../common/CallToAction";


interface ICustomConfirmationModalProps {
    handleCancelAction?: () => void;
    discardAction: () => void;
    confirmAction: () => void;
    showCancelOption?: boolean;
    modalText: {
        header: string;
        message: string;
        discard: string;
        confirm: string;
    }
    modalSize?: string;
}

export const CustomConfirmationModal: React.FC<ICustomConfirmationModalProps> = (props) => {
    const { handleCancelAction, discardAction, confirmAction, showCancelOption, modalText, modalSize } = props;

    return (
        <ModalComponent modalSize={modalSize || "x-small"} css={styles.modalConatiner}>
            <div css={styles.modalTitle}>
                <img src="/images/Assessment_done.svg" />
                <div>{modalText.header}</div>
            </div>

            <div css={styles.modalBody}>
                {modalText.message}
            </div>

            <div css={styles.modalActions}>
                {showCancelOption && <div css={styles.cancelButtonStyles} onClick={handleCancelAction}>Cancel</div>}
                <div css={styles.primaryActions}>
                    <CTA innerText={modalText.discard} theme={CTATheme.LIGHT} onClick={discardAction} customStyle={styles.discardButtonStyles} />
                    <CTA innerText={modalText.confirm} theme={CTATheme.PRIMARY} onClick={confirmAction} customStyle={styles.buttonStyles} />
                </div>
            </div>
        </ModalComponent>
    )
}